import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  MenuItem,
  Modal,
  Fade,
  Backdrop,
  FormControlLabel,
  Checkbox,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  TableContainer,
} from "@mui/material";

import { toast } from "react-toastify";
import { layoutCSS } from "../component/common/commonStyle";

import {
  useGetMissedCallNumbersQuery,
  useFetchPrincipalEntitiesQuery,
  useGetTemplatesByPrincipalQuery,
  useFetchHeadersByPrincipalIdQuery,
  useUpdateMissedCallConfigMutation,
} from "../store/services/missedCallApi";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "#fff",
  borderRadius: "12px",
  boxShadow: 24,
  p: 4,
};

const thStyle = {
  padding: "8px",
  borderBottom: "1px solid #ddd",
  textAlign: "left",
  fontWeight: 600,
  fontSize: "0.8rem",
};

const tdStyle = {
  padding: "8px",
  border: "1px solid #ccc",
  fontSize: "0.8rem",
  maxWidth: "150px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};


const tdSx = {
  fontSize: "0.8rem",
  py: 1,
  px: 1.5,
  borderBottom: "0.5px solid #1b1b1bff",
  borderRight: "0.5px solid #1b1b1bff",
};

const longTextSx = {
  maxWidth: "200px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const longTextStyle = {
  ...tdStyle,
  maxWidth: "200px",
};

const MissedCall = () => {
  const { data: numbersData } = useGetMissedCallNumbersQuery();
  const { data: entityData } = useFetchPrincipalEntitiesQuery();
  const [updateConfig] = useUpdateMissedCallConfigMutation();

  const [open, setOpen] = useState(false);

  const [form, setForm] = useState({
    missedcall_numberid: "",
    virtual_number: "",
    forward_to_mobile: "",
    forward_to_email: "",
    sender_id: "",
    template_id: "",
    template_text: "",
    template_trai_id: "",
    template_type: "",
    response_enabled: false,
    alert_mobile_enabled: false,
    alert_email_enabled: false,
    response_template_id: "",
    response_text: "",
    restemplate_id: "",
    entity_id: "",
    principalentity_id: "",
    is_active: true,
  });

  const { data: headersData } = useFetchHeadersByPrincipalIdQuery(
    form.principalentity_id || 0,
  );

  const { data: templatesData } = useGetTemplatesByPrincipalQuery(
    form.principalentity_id || 0,
  );

  const templates = templatesData?.data || [];

  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [isAlertTemplate, setIsAlertTemplate] = useState(false);
  const [isResponseTemplate, setIsResponseTemplate] = useState(false);

  /* ---------------- RESPONSE TEXT SELECT ---------------- */
  const handleResponseTextSelect = (templateId) => {
    const temp = templates.find((t) => `${t.template_id}` === `${templateId}`);
    if (!temp) return;

    setForm((s) => ({
      ...s,
      response_template_id: temp.template_id,
      response_text: temp.template_text,
      restemplate_id: temp.template_id,
    }));
  };

  /* ---------------- ALERT TEMPLATE SELECT ---------------- */
  const handleTemplateSelect = (templateId) => {
    const temp = templates.find((t) => `${t.template_id}` === `${templateId}`);
    if (!temp) return;

    setForm((s) => ({
      ...s,
      template_id: temp.template_id,
      template_text: temp.template_text,
      template_trai_id: temp.trai_template_id,
      template_type: temp.template_type,
    }));
  };

  /* ---------------- CONFIGURE CLICK ---------------- */
  const handleConfigure = (row) => {
    const entityMatch = entityData?.data?.find(
      (e) => `${e.pe_id}` === `${row.entity_id}`,
    );

    const matchedTemplate = templates.find(
      (t) => `${t.template_id}` === `${row.template_id}`,
    );
    const matchedHeader = headersData?.data?.find(
      (h) => `${h.header_name}` === `${row.sender_id}`,
    );
    setForm({
      missedcall_numberid: row.missedcall_numberid,
      virtual_number: row.virtual_number,
      forward_to_mobile: row.forward_to_mobile || "",
      forward_to_email: row.forward_to_email || "",
      sender_id: matchedHeader?.header_id || "",
      template_id: "",
      template_text: matchedTemplate?.template_text || row.template_text || "",
      template_trai_id: matchedTemplate?.trai_template_id || "",
      template_type: matchedTemplate?.template_type || "",
      entity_id: row.entity_id ?? "",
      principalentity_id:
        row.principalentity_id ?? entityMatch?.principalentity_id ?? "",
      response_enabled: row.response_text ? true : false,
      response_template_id: row.response_template_id || "",
      alert_mobile_enabled: row.forward_to_mobile ? true : false,
      alert_email_enabled: row.forward_to_email ? true : false,
      response_text: row.response_text || "",
      // restemplate_id: row.restemplate_id || "",
      restemplate_id: "",
      is_active: row.is_active,
    });

    setOpen(true);
  };

  /* ---------------- ENTITY SELECT ---------------- */
  const handleEntitySelect = (peId) => {
    const selectedEntity = entityData?.data?.find(
      (x) => `${x.pe_id}` === `${peId}`,
    );
    if (!selectedEntity) return;

    setForm((s) => ({
      ...s,
      entity_id: String(selectedEntity.pe_id),
      principalentity_id: selectedEntity.principalentity_id,
      template_id: "",
      template_text: "",
      template_trai_id: "",
      response_template_id: "",
      response_text: "",
      restemplate_id: "",
    }));
  };

  /* ---------------- INPUT CHANGE ---------------- */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((s) => ({
      ...s,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  /* ---------------- SUBMIT ---------------- */
  const handleSubmit = async () => {
    if (
      (form.alert_mobile_enabled || form.alert_email_enabled) &&
      !form.template_id
    ) {
      toast.error("Please select Alert Template");
      return;
    }
    if (form.response_enabled && !form.restemplate_id) {
      toast.error("Please select Reply Template");
      return;
    }
    const payload = {
      missedcall_numberid: form.missedcall_numberid,
      virtual_number: form.virtual_number,
      forward_to_mobile: form.alert_mobile_enabled
        ? form.forward_to_mobile
        : "",
      forward_to_email: form.alert_email_enabled ? form.forward_to_email : "",
      alert_mobile_enabled: form.alert_mobile_enabled,
      alert_email_enabled: form.alert_email_enabled,
      sender_id: form.sender_id,
      ...(form.template_id && { template_id: form.template_id }),
      template_text: form.template_text,
      template_trai_id: form.template_trai_id,
      template_type: form.template_type,
      response_enabled: form.response_enabled,
      response_template_id: form.response_template_id,
      response_text: form.response_enabled ? form.response_text : "",
      // restemplate_id: form.restemplate_id || null,
      restemplate_id: form.response_enabled
        ? form.restemplate_id || null
        : null,
      entity_id: form.entity_id ? form.entity_id : null,
      principalentity_id: form.principalentity_id,
      is_active: form.is_active,
    };

    try {
      const res = await updateConfig(payload);
      const success = res?.data?.success ?? false;

      if (success) {
        toast.success("Configuration Updated Successfully!");
        setOpen(false);
      } else {
        toast.error("Failed to update configuration");
      }
    } catch (err) {
      toast.error("Failed to update configuration");
    }
  };

  return (
    <Box sx={layoutCSS}>
      <Typography
        variant="h6"
        sx={{ mb: 2, fontSize: "0.95rem", fontWeight: "bold" }}
      >
        Missed Call Configuration
      </Typography>

      <Paper
        elevation={1}
        sx={{
          mt: 2,
          p: 2,
          borderRadius: "10px",
          overflowX: "auto",
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "0.85rem", mb: 1 }}>
          Missed Call Numbers List
        </Typography>

        <TableContainer component={Paper} sx={{ borderRadius: 0.5, border: "1px solid #e0e0e0" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  "MissedCall Number",
                  "Alert Mobile",
                  "Alert Email",
                  "Entity",
                  "Sender ID",
                  "Alert Message",
                  "Reply Message",
                  "Action",
                ].map((head) => (
                  <TableCell
                    key={head}
                    sx={{
                      bgcolor: "#0288d1",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                      py: 1,
                      borderRight: "0.5px solid #1b1b1bff",
                      textTransform: "capitalize",
                    }}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {numbersData?.data?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                      No data found.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                numbersData?.data?.map((row) => (
                  <TableRow
                    key={row.missedcall_numberid}
                    hover
                    sx={{ "&:last-child td, &:last-child th": { borderBottom: 0 } }}
                  >
                    <TableCell sx={tdSx}>{row.virtual_number}</TableCell>
                    <TableCell sx={tdSx}>{row.forward_to_mobile}</TableCell>
                    <TableCell sx={tdSx}>{row.forward_to_email}</TableCell>
                    <TableCell sx={tdSx}>{row.entity_id}</TableCell>
                    <TableCell sx={tdSx}>{row.sender_id}</TableCell>

                    <TableCell sx={{ ...tdSx, ...longTextSx }} title={row.template_text}>
                      {row.template_text}
                    </TableCell>

                    <TableCell sx={{ ...tdSx, ...longTextSx }} title={row.response_text}>
                      {row.response_text}
                    </TableCell>

                    <TableCell sx={tdSx}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleConfigure(row)}
                        sx={{ fontSize: "0.7rem" }}
                      >
                        Configure
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* ================= MODAL ================= */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
      >
        <Fade in={open}>
          <Box sx={modalStyle}>
            <Typography
              variant="h6"
              sx={{ mb: 2, fontWeight: "bold", fontSize: "0.95rem" }}
            >
              Configure Missed Call Number
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.alert_mobile_enabled}
                      name="alert_mobile_enabled"
                      onChange={handleChange}
                    />
                  }
                  label="Enable Alert Mobile"
                />

                {form.alert_mobile_enabled && (
                  <TextField
                    label="Alert Mobile"
                    fullWidth
                    name="forward_to_mobile"
                    value={form.forward_to_mobile}
                    onChange={handleChange}
                    size="small"
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.alert_email_enabled}
                      name="alert_email_enabled"
                      onChange={handleChange}
                    />
                  }
                  label="Enable Alert Email"
                />

                {form.alert_email_enabled && (
                  <TextField
                    label="Alert Email"
                    fullWidth
                    name="forward_to_email"
                    value={form.forward_to_email}
                    onChange={handleChange}
                    size="small"
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Entity"
                  fullWidth
                  value={form.entity_id}
                  onChange={(e) => handleEntitySelect(e.target.value)}
                  size="small"
                >
                  {entityData?.data?.map((item) => (
                    <MenuItem key={item.pe_id} value={item.pe_id}>
                      {item.pe_name} ({item.pe_id})
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Sender ID"
                  fullWidth
                  name="sender_id"
                  value={form.sender_id}
                  onChange={handleChange}
                  size="small"
                >
                  {headersData?.data?.map((h) => (
                    <MenuItem key={h.header_id} value={h.header_id}>
                      {h.header_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* ALERT TEMPLATE BUTTON */}
              {(form.alert_mobile_enabled || form.alert_email_enabled) && (
                <Grid item xs={12}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      setIsAlertTemplate(true);
                      setIsResponseTemplate(false);
                      setIsTemplateModalOpen(true);
                    }}
                    sx={{ textTransform: "none" }}
                  >
                    Alert Message
                  </Button>

                  <Typography sx={{ fontSize: "0.75rem", mt: 1 }}>
                    {form.template_text || "No template selected"}
                  </Typography>
                </Grid>
              )}

              {/* RESPONSE TEMPLATE BUTTON */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.response_enabled}
                      name="response_enabled"
                      onChange={handleChange}
                    />
                  }
                  label="Enable Reply Message"
                />
              </Grid>

              {form.response_enabled && (
                <Grid item xs={12}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => {
                      setIsAlertTemplate(false);
                      setIsResponseTemplate(true);
                      setIsTemplateModalOpen(true);
                    }}
                    sx={{ textTransform: "none" }}
                  >
                    Reply Message
                  </Button>

                  <Typography sx={{ fontSize: "0.75rem", mt: 1 }}>
                    {form.response_text || "No reply template selected"}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={12}>
                <Box sx={{ textAlign: "right" }}>
                  <Button
                    variant="contained"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                  >
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>

      {/* ================= TEMPLATE MODAL ================= */}
      <Dialog
        open={isTemplateModalOpen}
        onClose={() => setIsTemplateModalOpen(false)}
      >
        <DialogTitle
          sx={{
            fontSize: "0.80rem",
            color: "#333",
            fontWeight: "bold",
            paddingBottom: "6px",
          }}
        >
          Select Template
        </DialogTitle>

        <DialogContent sx={{ maxHeight: "350px", overflowY: "auto" }}>
          {templates.length > 0 ? (
            <List>
              {templates.map((template) => (
                <ListItem
                  button
                  key={template.template_id}
                  onClick={() => {
                    if (isAlertTemplate) {
                      handleTemplateSelect(template.template_id);
                    }
                    if (isResponseTemplate) {
                      handleResponseTextSelect(template.template_id);
                    }
                    setIsTemplateModalOpen(false);
                  }}
                >
                  <ListItemText
                    primary={
                      <>
                        <strong>Template Name:</strong> {template.template_name}
                        <br />
                        <strong>Text:</strong> {template.template_text}
                      </>
                    }
                    secondary={<>ID: {template.trai_template_id}</>}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography>No templates available</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setIsTemplateModalOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MissedCall;
